import { SettingsBase } from './SettingsBase';

export class SprintSettings extends SettingsBase {
    static NAME_OF_CLASS = 'SprintSettings';
    /**
     * If true, the backup times will be added as transactions
     */
    public TimingMode: boolean = false;

    /**
     * If set, then you just press enter after typing the bib to record a time, and it will move to the next field automatically.
     * @remarks This only works if the TimingMode is also enabled.
     */
    public QuickTiming: boolean = false;

    /**
     * A list of the filtered categories for this sprint.
     */
    public Categories: number[] = [];

    /**
     * The filtered level for this sprint.
     */
    public Level: string | null = null;

    public constructor(val?: SprintSettings) {
        super();
        this.TimingMode = val?.TimingMode ?? false;
        this.Categories = val?.Categories ?? [];
        this.Level = val?.Level ?? null;
        this.QuickTiming = val?.QuickTiming ?? false;
    }
}
